import RepositoryService from 'src/services/repository'

const resource = 'recordType'

export default {
  ...RepositoryService.utils.createCrudRepository(resource),
  restore: idList => RepositoryService.crud.post(`${resource}/restore`, { idList }),
}
